var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dashboard",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1D1D1B;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.1,4.9C15.2,1,8.8,1,4.9,4.9S1,15.2,4.9,19.1c1.4,1.4,3.2,2.4,5.1,2.7c5.4,1.1,10.7-2.4,11.8-7.9 c0.1-0.6,0.2-1.3,0.2-2C22,9.3,21,6.8,19.1,4.9z M19.1,16.7c-2.6,3.9-7.9,5-11.8,2.4s-5-7.9-2.4-11.8s7.9-5,11.8-2.4 c2.4,1.6,3.8,4.2,3.8,7.1C20.5,13.7,20,15.3,19.1,16.7L19.1,16.7z M13.5,12c0,0.8-0.7,1.5-1.5,1.5c-0.8,0-1.5-0.7-1.5-1.5 c0-0.6,0.3-1.1,0.8-1.4c0-0.1,0-0.1,0-0.2V5.1c0-0.4,0.3-0.8,0.8-0.8c0.4,0,0.8,0.3,0.8,0.8v5.4c0,0.1,0,0.1,0,0.2 C13.2,10.9,13.5,11.4,13.5,12z M7.5,12c0,0.4-0.3,0.8-0.8,0.8H5.2c-0.4,0-0.8-0.3-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8h1.6 C7.2,11.3,7.5,11.6,7.5,12z M19.6,12c0,0.4-0.3,0.8-0.8,0.8h-1.6c-0.4,0-0.8-0.3-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8h1.6 C19.2,11.3,19.6,11.6,19.6,12z M8.7,7.6C9,7.9,9,8.4,8.7,8.7C8.5,9,8,9,7.7,8.7c0,0,0,0,0,0L6.5,7.6c-0.3-0.3-0.3-0.8,0-1.1 c0.3-0.3,0.8-0.3,1.1,0c0,0,0,0,0,0L8.7,7.6z M17.5,7.6l-1.1,1.1C16,9,15.6,9,15.3,8.7c-0.3-0.3-0.3-0.8,0-1l1.1-1.1 c0.3-0.3,0.8-0.3,1.1,0C17.8,6.8,17.8,7.3,17.5,7.6C17.5,7.6,17.5,7.6,17.5,7.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.804f4841.svg";
export { ForwardRef as ReactComponent };